import Menu from '@zenbusiness/zui/Menu';
import { styled } from '@zenbusiness/zui/styles';

import MenuItem from '#client/components/MenuItem';

const MenuStyle = ({ theme }) => ({
  '& .MuiPaper-root': {
    padding: '8px 0',
    border: `1px solid ${theme.palette.border.main}`,
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: '16px'
  }
});

const MenuItemStyle = ({ theme }) => ({
  padding: '8px 16px !important',
  fontSize: '14px !important',
  fontWeight: '600 !important',
  lineHeight: '16px !important',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: `${theme.palette.background.grey.main} !important`,
    color: theme.palette.text.primary
  }
});

export const MenuStyled = styled(Menu)(MenuStyle);
export const MenuItemStyled = styled(MenuItem)(MenuItemStyle);
